import content from "./jsonParsers/content.json";

const FooterSet = {
  footer1: content.Results.footer1,
  footer2: content.Results.footer2,
  copyright: content.Results.copyright,
  footerLink1: content.Results.footerLink1,
  footerLink2: content.Results.footerLink2,
  copied: content.Results.copied,
};

export default FooterSet;
